/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system'
import {
  PROMETHEAN_DARK_PURPLE,
  PROMETHEAN_MEDIUM_SHADOW,
  PROMETHEAN_TEXT_HEADER,
  PROMETHEAN_TYPOGRAPHY_H4,
  PROMETHEAN_TYPOGRAPHY_SMALL_TEXT,
  PROMETHEAN_TYPOGRAPHY_BODY,
  PROMETHEAN_NEUTRAL_DARK_GREY,
  PROMETHEAN_NO_SHADOW,
  PROMETHEAN_BLUE,
} from '@prom/web-embers'

export const StyledTitledCard = styled('div')({
  position: 'relative',
  '.TitledCard': {
    '&-shadow': {
      position: 'absolute',
      width: 430,
      height: 28,
      bottom: -28,
      transform: 'translateX(-50%)',
      left: '50%',
      background: PROMETHEAN_DARK_PURPLE,
      opacity: 0.5,
      filter: 'blur(32px)',
      zIndex: 0,
    },
    '&-card': {
      position: 'relative',
      width: 446,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      margin: '0 !important',
      zIndex: 1,

      '&.MuiPaper-elevation': {
        ...PROMETHEAN_MEDIUM_SHADOW,
        borderRadius: 8,
        overflow: 'hidden',
      },

      '&.MuiPaper-root': {
        padding: '96px 48px 40px',
        '&:last-child': {
          paddingBottom: 40,
        },
      },

      '.OIDCHeader-root': {
        marginLeft: -48,
        marginRight: -48,
        marginTop: -96,
        marginBottom: 40,
      },

      '.divider': {
        display: 'block',
        margin: '41px 0',
        width: '100%',
        height: '1px',
        backgroundColor: PROMETHEAN_NEUTRAL_DARK_GREY,
        overflow: 'hidden',
      },

      '&-narrow': {
        '&.MuiPaper-root': {
          padding: '96px 65px 40px',
        },
        '.TitledCard-subtitle': {
          textAlign: 'center !important',
          marginBottom: 16,
        },
        '.OIDCHeader-root': {
          marginLeft: -65,
          marginRight: -65,
        },
      },

      '.EmbersLabeledBox-disabled .MuiFormControlLabel-label.Mui-disabled': {
        color: PROMETHEAN_NEUTRAL_DARK_GREY,
      },
    },
    '&-title': {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 32,
      justifyContent: 'center',
      columnGap: 16,
      h1: {
        ...PROMETHEAN_TYPOGRAPHY_H4,
        color: PROMETHEAN_TEXT_HEADER,
      },
      '&.left': {
        justifyContent: 'start',
        alignItems: 'baseline',
        textAlign: 'left',
        '.TitledCard-iconBack': {
          position: 'relative',
          top: -2,
        },
      },
    },
    '&-subtitle': {
      ...PROMETHEAN_TYPOGRAPHY_SMALL_TEXT,
      marginBottom: 16,
      textAlign: 'left',
    },
    '&-description': {
      ...PROMETHEAN_TYPOGRAPHY_BODY,
      marginBottom: 16,
      textAlign: 'left',
    },
    '&-iconBack': {
      display: 'flex',
      cursor: 'pointer',
      ':focus-visible': {
        outline: `2px solid ${PROMETHEAN_BLUE}`,
      },
    },
  },
  '@media screen and (max-width: 446px)': {
    width: '100%',
    '.TitledCard': {
      '&-shadow': {
        display: 'none',
      },

      '&-card': {
        width: '100%',

        '.OIDCHeader-root': {
          marginLeft: -32,
          marginRight: -32,
          marginTop: -106,
          marginBottom: 40,
        },

        '&.MuiPaper-elevation': {
          ...PROMETHEAN_NO_SHADOW,
          borderRadius: 0,
        },

        '&.MuiPaper-root': {
          padding: '106px 32px 40px',
          '&:last-child': {
            paddingBottom: 40,
          },
        },

        '&-narrow': {
          '.OIDCHeader-root': {
            marginLeft: -29.5,
            marginRight: -29.5,
          },
          '&.MuiPaper-root': {
            padding: '106px 29.5px 40px',
          },
        },
      },
    },
  },
})
